import constants from '../constants';
import OrderPayment from '../Model/Payment';
import authAxios from '../authorization/axios';

export class PaymentsService {

  getPaymentsFromOrderId(orderId: number) {
    return authAxios.get(constants.api.getOrderPayments.replace('{orderId}', `${  orderId}`))
      .then<(OrderPayment & { currency: string })[]>(res => {
      return res.data.data;
    });
  }

}